<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   <m-single-product-201 v-bind='{...{"storeLastName":false,"productLink":null,"relatedProducts":true,"productCardName":"mProductCard309","relatedCourse":false,"galleryFullSlider":false,"productAuthor":false,"showSpecifiedFeature":"","showVariationProductImage":false,"mapFeatureName":null,"variationProductComponent":"VariationProduct","showDescription":true,"showFeatures":true,"showComments":true},...{}}' :style='"margin: 120px auto 30px auto;"' class="" >
                <template #default>   </template>
                </m-single-product-201></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mSingleProduct201 from '@moeinmdn/miw-alpha-components/src/package/Product/Single/SingleProduct201';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mSingleProduct201 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
